import React from 'react';
import clsx from 'clsx';
import { CheckSmallIcon } from '../../assets/icons';
import { StyleVariables } from '../styleConstants';

export type MultiselectOption = {
  text: string;
  code: string;
  isSelected?: boolean;
};

const MultiselectOptionButton = (props: {
  reason: string;
  isSelected: boolean;
  onSelectedChanged: (selected: boolean) => void;
}) => {
  const { reason, isSelected, onSelectedChanged } = props;
  return (
    <button
      className={clsx('multiselect__option-container', {
        'multiselect__option-container--selected': isSelected,
      })}
      onClick={() => onSelectedChanged(!isSelected)}
    >
      <div className="multiselect__option-body">
        <div className="flex-grow-1 text-left" data-test="multiselect__option">
          {reason}
        </div>
        {isSelected && (
          <CheckSmallIcon fill={StyleVariables.cyan500} data-test="multiselect__option-tick" />
        )}
      </div>
    </button>
  );
};

export const Multiselect = <T extends MultiselectOption>(props: {
  options: T[];
  onOptionsChanged: (selectedReasons: T[]) => void;
}) => {
  const { options, onOptionsChanged } = props;

  const onChanged = (option: T, update: { isSelected?: boolean }) =>
    onOptionsChanged(options.map((x) => (x.code === option.code ? { ...x, ...update } : x)));

  return (
    <>
      {options.map((option) => (
        <MultiselectOptionButton
          key={`option_${option.code}`}
          reason={option.text}
          isSelected={option.isSelected ?? false}
          onSelectedChanged={(isSelected) => {
            onChanged(option, { isSelected });
          }}
        />
      ))}
    </>
  );
};
